import React, {useCallback, useState} from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import OptionContainer from 'ui-library/menus/OptionContainer';

import {GetTableDataFn} from './extractTableDataForSuggestions';
import SuggestedPlotsHoverOption from './SuggestedPlotsHoverOption';

const BUTTON_TITLE = 'Add to analysis';

interface SuggestedPlotsDropdownProps {
  entryId: string;
  tableName: string;
  getTableData: GetTableDataFn;
  disabled?: boolean;
  className?: string;
}

export default function SuggestedPlotsDropdown({
  entryId,
  tableName,
  getTableData,
  disabled,
  className,
}: SuggestedPlotsDropdownProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <Tooltip title={BUTTON_TITLE}>
      <Dropdown
        isOpen={isOpen}
        onToggle={setIsOpen}
        closeOnInsideClick={false}
        menu={
          <Menu dropLeft={true} height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.MEDIUM}>
            <OptionContainer shouldEllipsize={true}>
              <SuggestedPlotsHoverOption
                entryId={entryId}
                tableName={tableName}
                getTableData={getTableData}
                onSuggestionChosen={handleClose}
              />
            </OptionContainer>
          </Menu>
        }
      >
        <Button
          disabled={disabled}
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          size={ButtonSize.MINI}
          className={className}
          icon={ModelTypeConstants.ANALYSIS}
          iconAltText={BUTTON_TITLE}
          isDropdown={true}
          dataTestAttrs={{
            component: 'SuggestedPlotsButton',
            element: 'button',
          }}
        />
      </Dropdown>
    </Tooltip>
  );
}
